import { render, staticRenderFns } from "./clientdashboard-my-advisor.vue?vue&type=template&id=7d2d894a&"
import script from "./clientdashboard-my-advisor.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-my-advisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports